import React from 'react';

const ProTooltipContent = (
  <>
    <strong>PRO feature</strong>: click to upgrade and unlock it
  </>
);

export default ProTooltipContent;
